/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'
import { Listbox } from '@headlessui/react'
import { CheckIcon } from '@heroicons/react/20/solid'
import { UiSelectOption } from '../UiSelect'

interface UiSelectOptionsListProps {
    options: UiSelectOption[]
}

const UiSelectOptionsList = (props: UiSelectOptionsListProps) => {
    if (!props.options.length) {
        return null
    }

    return (
        <>
            {props.options.map((option) => (
                <Listbox.Option
                    key={option.value}
                    className={({ active }) =>
                        clsx(
                            'relative cursor-default select-none py-2 pl-10 pr-4',
                            active
                                ? 'bg-gray-100 text-gray-900 dark:bg-gray-800 dark:text-gray-100'
                                : 'text-gray-900 dark:text-gray-300'
                        )
                    }
                    value={option.value}
                >
                    {({ selected }) => (
                        <>
                            <span
                                className={clsx(
                                    'block truncate',
                                    selected ? 'font-semibold' : 'font-normal'
                                )}
                            >
                                {option.label}
                            </span>
                            {selected ? (
                                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-primary-600">
                                    <CheckIcon
                                        className="size-5"
                                        aria-hidden="true"
                                    />
                                </span>
                            ) : null}
                        </>
                    )}
                </Listbox.Option>
            ))}
        </>
    )
}

export default UiSelectOptionsList
